import { NavLink } from "react-router";

import Avatar from "@/design/components/Avatar";
import { viCalendar } from "@sippy-platform/valkyrie";

import { Card, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

export default function HolidaySetsCard({ holidaySet }) {
  return (
    <Card>
      <List>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={`../holidaysets/${holidaySet.id}`}>
            <ListItemAvatar>
              <Avatar text={holidaySet.name} icon={viCalendar} />
            </ListItemAvatar>
            <ListItemText primary={holidaySet.name} />
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

HolidaySetsCard.propTypes = {
  holidaySet: PropTypes.object,
};
